// api.js
export const getTransactions = async (gameId, setTransactions) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/getBankTransactions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ gameId: gameId }),
    });

    const result = await response.json();
    if (result.transactions) {
      console.log("Response from API:", result);
      setTransactions(result.transactions.reverse());
    }
  } catch (error) {
    console.error("Error calling API:", error);
  }
};

export const loadUserData = async (token, gameId, setAdmin) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/getPlayerData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: token, gameId: gameId }),
    });

    const result = await response.json();
    if (result.balance) {
      setAdmin(result.isAdmin);
    }
  } catch (error) {
    console.error("Error calling API:", error);
  }
};

export const loadUsers = async (token, gameId, setUsers,   setPlayer = () => {}) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get-game-users`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: token, game_id: gameId }),
    });

    const result = await response.json();
    if (result.players && result.user) {
      setUsers(result.players);
      setPlayer(result.username);

    }
  } catch (error) {
    console.error("Error calling API:", error);
  }
};
